function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import { SliderMixin, keyCodes } from '../slider/slider-utils.js';
import { stopAndPrevent } from '../../utils/event.js';
import { between } from '../../utils/format.js';
var dragType = {
  MIN: 0,
  RANGE: 1,
  MAX: 2
};
export default Vue.extend({
  name: 'QRange',
  mixins: [SliderMixin],
  props: {
    value: {
      type: Object,
      "default": function _default() {
        return {
          min: null,
          max: null
        };
      },
      validator: function validator(v) {
        return 'min' in v && 'max' in v;
      }
    },
    dragRange: Boolean,
    dragOnlyRange: Boolean,
    leftLabelColor: String,
    leftLabelTextColor: String,
    rightLabelColor: String,
    rightLabelTextColor: String,
    leftLabelValue: [String, Number],
    rightLabelValue: [String, Number],
    leftThumbColor: String,
    rightThumbColor: String
  },
  data: function data() {
    var innerMin = this.__getInnerMin(this.innerMin);

    var innerMax = this.__getInnerMax(this.innerMax);

    return {
      model: {
        min: this.value.min === null ? innerMin : between(this.value.min, innerMin, innerMax),
        max: this.value.max === null ? innerMax : between(this.value.max, innerMin, innerMax)
      },
      curMinRatio: 0,
      curMaxRatio: 0
    };
  },
  computed: {
    modelMinRatio: function modelMinRatio() {
      return this.__convertModelToRatio(this.model.min);
    },
    modelMaxRatio: function modelMaxRatio() {
      return this.__convertModelToRatio(this.model.max);
    },
    ratioMin: function ratioMin() {
      return this.active === true ? this.curMinRatio : this.modelMinRatio;
    },
    ratioMax: function ratioMax() {
      return this.active === true ? this.curMaxRatio : this.modelMaxRatio;
    },
    selectionBarStyle: function selectionBarStyle() {
      var _acc;

      var acc = (_acc = {}, _defineProperty(_acc, this.positionProp, "".concat(100 * this.ratioMin, "%")), _defineProperty(_acc, this.sizeProp, "".concat(100 * (this.ratioMax - this.ratioMin), "%")), _acc);

      if (this.selectionImg !== void 0) {
        acc.backgroundImage = "url(".concat(this.selectionImg, ") !important");
      }

      return acc;
    },
    trackContainerEvents: function trackContainerEvents() {
      var _this = this;

      if (this.editable !== true) {
        return {};
      }

      if (this.$q.platform.is.mobile === true) {
        return {
          click: this.__onMobileClick
        };
      }

      var evt = {
        mousedown: this.__onActivate
      };

      if (this.dragRange === true || this.dragOnlyRange === true) {
        Object.assign(evt, {
          focus: function focus() {
            _this.focus = 'both';
          },
          blur: this.__onBlur,
          keydown: this.__onKeydown,
          keyup: this.__onKeyup
        });
      }

      return evt;
    },
    trackContainerAttrs: function trackContainerAttrs() {
      return {
        tabindex: this.$q.platform.is.mobile !== true && (this.dragRange || this.dragOnlyRange === true) ? this.computedTabindex : null
      };
    },
    thumbAttrs: function thumbAttrs() {
      return {
        tabindex: this.dragOnlyRange !== true ? this.computedTabindex : null
      };
    },
    thumbMinEvents: function thumbMinEvents() {
      return this.__getEvents('min');
    },
    thumbMaxEvents: function thumbMaxEvents() {
      return this.__getEvents('max');
    },
    thumbMinLabel: function thumbMinLabel() {
      return this.leftLabelValue !== void 0 ? this.leftLabelValue : this.model.min;
    },
    thumbMaxLabel: function thumbMaxLabel() {
      return this.rightLabelValue !== void 0 ? this.rightLabelValue : this.model.max;
    },
    thumbMinClasses: function thumbMinClasses() {
      var color = this.leftThumbColor || this.thumbColor || this.color;
      return "q-slider__thumb q-slider__thumb".concat(this.axis, " q-slider__thumb").concat(this.axis, "-").concat(this.isReversed === true ? 'rtl' : 'ltr', " absolute non-selectable") + (this.preventFocus === false && (this.focus === 'min' || this.focus === 'both') ? ' q-slider--focus' : '') + (color !== void 0 ? " text-".concat(color) : '');
    },
    thumbMaxClasses: function thumbMaxClasses() {
      var color = this.rightThumbColor || this.thumbColor || this.color;
      return "q-slider__thumb q-slider__thumb".concat(this.axis, " q-slider__thumb").concat(this.axis, "-").concat(this.isReversed === true ? 'rtl' : 'ltr', " absolute non-selectable") + (this.preventFocus === false && (this.focus === 'max' || this.focus === 'both') ? ' q-slider--focus' : '') + (color !== void 0 ? " text-".concat(color) : '');
    },
    thumbMinStyle: function thumbMinStyle() {
      var _ref;

      return _ref = {
        width: this.thumbSize,
        height: this.thumbSize
      }, _defineProperty(_ref, this.positionProp, "".concat(100 * this.ratioMin, "%")), _defineProperty(_ref, "zIndex", this.focus === 'min' ? 2 : void 0), _ref;
    },
    thumbMaxStyle: function thumbMaxStyle() {
      var _ref2;

      return _ref2 = {
        width: this.thumbSize,
        height: this.thumbSize
      }, _defineProperty(_ref2, this.positionProp, "".concat(100 * this.ratioMax, "%")), _defineProperty(_ref2, "zIndex", this.focus === 'max' ? 2 : void 0), _ref2;
    },
    thumbMinPinColor: function thumbMinPinColor() {
      var color = this.leftLabelColor || this.labelColor;
      return color !== void 0 ? " text-".concat(color) : '';
    },
    thumbMaxPinColor: function thumbMaxPinColor() {
      var color = this.rightLabelColor || this.labelColor;
      return color !== void 0 ? " text-".concat(color) : '';
    },
    thumbMinTextContainerStyle: function thumbMinTextContainerStyle() {
      return this.__getTextContainerStyle(this.ratioMin);
    },
    thumbMaxTextContainerStyle: function thumbMaxTextContainerStyle() {
      return this.__getTextContainerStyle(this.ratioMax);
    },
    thumbMinTextClass: function thumbMinTextClass() {
      var color = this.leftLabelTextColor || this.labelTextColor;
      return 'q-slider__text' + (color !== void 0 ? " text-".concat(color) : '');
    },
    thumbMaxTextClass: function thumbMaxTextClass() {
      var color = this.rightLabelTextColor || this.labelTextColor;
      return 'q-slider__text' + (color !== void 0 ? " text-".concat(color) : '');
    },
    formAttrs: function formAttrs() {
      return {
        type: 'hidden',
        name: this.name,
        value: "".concat(this.value.min, "|").concat(this.value.max)
      };
    },
    modelUpdate: function modelUpdate() {
      return "".concat(this.value.min, "|").concat(this.value.max, "|").concat(this.computedInnerMin, "|").concat(this.computedInnerMax);
    }
  },
  watch: {
    modelUpdate: function modelUpdate() {
      this.model.min = this.value.min === null ? this.computedInnerMin : between(this.value.min, this.computedInnerMin, this.computedInnerMax);
      this.model.max = this.value.max === null ? this.computedInnerMax : between(this.value.max, this.computedInnerMin, this.computedInnerMax);
    }
  },
  methods: {
    __updateValue: function __updateValue(change) {
      if (this.model.min !== this.value.min || this.model.max !== this.value.max) {
        this.$emit('input', _objectSpread({}, this.model));
      }

      change === true && this.$emit('change', _objectSpread({}, this.model));
    },
    __getDragging: function __getDragging(event) {
      var _this$$el$getBounding = this.$el.getBoundingClientRect(),
          left = _this$$el$getBounding.left,
          top = _this$$el$getBounding.top,
          width = _this$$el$getBounding.width,
          height = _this$$el$getBounding.height,
          sensitivity = this.dragOnlyRange === true ? 0 : this.vertical === true ? this.$refs.minThumb.offsetHeight / (2 * height) : this.$refs.minThumb.offsetWidth / (2 * width);

      var dragging = {
        left: left,
        top: top,
        width: width,
        height: height,
        valueMin: this.model.min,
        valueMax: this.model.max,
        ratioMin: this.modelMinRatio,
        ratioMax: this.modelMaxRatio
      };

      var ratio = this.__getDraggingRatio(event, dragging);

      if (this.dragOnlyRange !== true && ratio < dragging.ratioMin + sensitivity) {
        dragging.type = dragType.MIN;
      } else if (this.dragOnlyRange === true || ratio < dragging.ratioMax - sensitivity) {
        if (this.dragRange === true || this.dragOnlyRange === true) {
          dragging.type = dragType.RANGE;
          Object.assign(dragging, {
            offsetRatio: ratio,
            offsetModel: this.__convertRatioToModel(ratio),
            rangeValue: dragging.valueMax - dragging.valueMin,
            rangeRatio: dragging.ratioMax - dragging.ratioMin
          });
        } else {
          dragging.type = dragging.ratioMax - ratio < ratio - dragging.ratioMin ? dragType.MAX : dragType.MIN;
        }
      } else {
        dragging.type = dragType.MAX;
      }

      return dragging;
    },
    __updatePosition: function __updatePosition(event) {
      var dragging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dragging;
      var pos;

      var ratio = this.__getDraggingRatio(event, dragging);

      var localModel = this.__convertRatioToModel(ratio);

      switch (dragging.type) {
        case dragType.MIN:
          if (ratio <= dragging.ratioMax) {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMax,
              min: localModel,
              max: dragging.valueMax
            };
            this.focus = 'min';
          } else {
            pos = {
              minR: dragging.ratioMax,
              maxR: ratio,
              min: dragging.valueMax,
              max: localModel
            };
            this.focus = 'max';
          }

          break;

        case dragType.MAX:
          if (ratio >= dragging.ratioMin) {
            pos = {
              minR: dragging.ratioMin,
              maxR: ratio,
              min: dragging.valueMin,
              max: localModel
            };
            this.focus = 'max';
          } else {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMin,
              min: localModel,
              max: dragging.valueMin
            };
            this.focus = 'min';
          }

          break;

        case dragType.RANGE:
          var ratioDelta = ratio - dragging.offsetRatio,
              minR = between(dragging.ratioMin + ratioDelta, 0, 1 - dragging.rangeRatio),
              modelDelta = localModel - dragging.offsetModel,
              min = between(dragging.valueMin + modelDelta, this.min, this.max - dragging.rangeValue);
          pos = {
            minR: minR,
            maxR: minR + dragging.rangeRatio,
            min: parseFloat(min.toFixed(this.computedDecimals)),
            max: parseFloat((min + dragging.rangeValue).toFixed(this.computedDecimals))
          };
          this.focus = 'both';
          break;
      } // If either of the values to be emitted are null, set them to the defaults the user has entered.


      this.model = this.model.min === null || this.model.max === null ? {
        min: pos.min || this.min,
        max: pos.max || this.max
      } : {
        min: pos.min,
        max: pos.max
      };

      if (this.snap !== true || this.step === 0) {
        this.curMinRatio = pos.minR;
        this.curMaxRatio = pos.maxR;
      } else {
        this.curMinRatio = this.__convertModelToRatio(this.model.min);
        this.curMaxRatio = this.__convertModelToRatio(this.model.max);
      }
    },
    __getEvents: function __getEvents(side) {
      var _this2 = this;

      return this.$q.platform.is.mobile !== true && this.editable === true && this.dragOnlyRange !== true ? {
        focus: function focus() {
          _this2.focus = side;
        },
        blur: this.__onBlur,
        keydown: this.__onKeydown,
        keyup: this.__onKeyup
      } : {};
    },
    __onKeydown: function __onKeydown(evt) {
      if (!keyCodes.includes(evt.keyCode)) {
        return;
      }

      stopAndPrevent(evt);
      var stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * this.computedStep,
          offset = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (this.isReversed === true ? -1 : 1) * stepVal;

      if (this.focus === 'both') {
        var interval = this.model.max - this.model.min;
        var min = between(parseFloat((this.model.min + offset).toFixed(this.computedDecimals)), this.computedInnerMin, this.computedInnerMax - interval);
        this.model = {
          min: min,
          max: parseFloat((min + interval).toFixed(this.computedDecimals))
        };
      } else if (this.focus === false) {
        return;
      } else {
        var which = this.focus;
        this.model = _objectSpread(_objectSpread({}, this.model), {}, _defineProperty({}, which, between(parseFloat((this.model[which] + offset).toFixed(this.computedDecimals)), which === 'min' ? this.computedInnerMin : this.model.min, which === 'max' ? this.computedInnerMax : this.model.max)));
      }

      this.__updateValue();
    }
  },
  render: function render(h) {
    var _this3 = this;

    var content = this.__getContent(h, function (node) {
      node.push(_this3.__getThumb(h, {
        pinColor: _this3.thumbMinPinColor,
        textContainerStyle: _this3.thumbMinTextContainerStyle,
        textClass: _this3.thumbMinTextClass,
        label: _this3.thumbMinLabel,
        classes: _this3.thumbMinClasses,
        style: _this3.thumbMinStyle,
        nodeData: {
          ref: 'minThumb',
          key: 'tmin',
          on: _this3.thumbMinEvents,
          attrs: _this3.thumbAttrs
        }
      }), _this3.__getThumb(h, {
        pinColor: _this3.thumbMaxPinColor,
        textContainerStyle: _this3.thumbMaxTextContainerStyle,
        textClass: _this3.thumbMaxTextClass,
        label: _this3.thumbMaxLabel,
        classes: _this3.thumbMaxClasses,
        style: _this3.thumbMaxStyle,
        nodeData: {
          key: 'tmax',
          on: _this3.thumbMaxEvents,
          attrs: _this3.thumbAttrs
        }
      }));
    });

    return h('div', {
      "class": 'q-range ' + this.classes + (this.value.min === null || this.value.max === null ? ' q-slider--no-value' : ''),
      attrs: _objectSpread(_objectSpread({}, this.attributes), {}, {
        'aria-valuenow': this.value.min + '|' + this.value.max
      })
    }, content);
  }
});